import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var MoveAttract = /*#__PURE__*/function () {
  function MoveAttract() {
    _classCallCheck(this, MoveAttract);

    this.distance = 200;
    this.enable = false;
    this.rotate = {
      x: 3000,
      y: 3000
    };
  }

  _createClass(MoveAttract, [{
    key: "rotateX",
    get: function get() {
      return this.rotate.x;
    },
    set: function set(value) {
      this.rotate.x = value;
    }
  }, {
    key: "rotateY",
    get: function get() {
      return this.rotate.y;
    },
    set: function set(value) {
      this.rotate.y = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _data$rotate$x, _data$rotate, _data$rotate$y, _data$rotate2;

      if (!data) {
        return;
      }

      if (data.distance !== undefined) {
        this.distance = setRangeValue(data.distance);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      var rotateX = (_data$rotate$x = (_data$rotate = data.rotate) === null || _data$rotate === void 0 ? void 0 : _data$rotate.x) !== null && _data$rotate$x !== void 0 ? _data$rotate$x : data.rotateX;

      if (rotateX !== undefined) {
        this.rotate.x = rotateX;
      }

      var rotateY = (_data$rotate$y = (_data$rotate2 = data.rotate) === null || _data$rotate2 === void 0 ? void 0 : _data$rotate2.y) !== null && _data$rotate$y !== void 0 ? _data$rotate$y : data.rotateY;

      if (rotateY !== undefined) {
        this.rotate.y = rotateY;
      }
    }
  }]);

  return MoveAttract;
}();